module.exports = __webpack_public_path__ + "static/media/report_customer.2e2136fa.svg";